/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaContentObject } from '../../models/criteria-content-object';
import { TrustedCompanyContent } from '../../models/trusted-company-content';

export interface ApiMasterTrustedCompanyContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterTrustedCompanyContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterTrustedCompanyContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrustedCompanyContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrustedCompanyContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TrustedCompanyContent>>;
    })
  );
}

apiMasterTrustedCompanyContentGetByCriteriaPost.PATH = '/api/Master/TrustedCompanyContent/GetByCriteria';
